import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import FeaturesGrid from './components/FeaturesGrid';
import ServiceDiscovery from './components/ServiceDiscovery';
import CaseStudies from './components/CaseStudies';
import FAQ from './components/FAQ';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import LeadModal from './components/LeadModal';
import InfoModal, { InfoType } from './components/InfoModal';
import LoadingScreen from './components/LoadingScreen';

const App: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [infoModalType, setInfoModalType] = useState<InfoType>(null);
  const [isLoading, setIsLoading] = useState(true);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  
  const openInfoModal = (type: InfoType) => setInfoModalType(type);
  const closeInfoModal = () => setInfoModalType(null);

  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
      return;
    }
    
    document.body.style.overflow = 'unset';

    const observerOptions = {
      threshold: 0, 
      rootMargin: '25% 0px 25% 0px' 
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        } else {
          // Re-trigger the animation when scrolling back up/down
          entry.target.classList.remove('active');
        }
      });
    }, observerOptions);

    const revealElements = document.querySelectorAll('.reveal-item');
    revealElements.forEach(el => observer.observe(el));

    return () => {
      revealElements.forEach(el => observer.unobserve(el));
    };
  }, [isLoading]);

  return (
    <div className="relative bg-white">
      {isLoading && <LoadingScreen onFinished={() => setIsLoading(false)} />}
      
      <Navbar onOpenModal={openModal} />
      
      <main className={isLoading ? 'opacity-0' : 'opacity-100 transition-opacity duration-700'}>
        <Hero onOpenModal={openModal} />
        <Marquee />
        <FeaturesGrid />
        <ServiceDiscovery />
        <CaseStudies />
        <FAQ />
        <ContactSection />
      </main>

      {!isLoading && <Footer onOpenInfo={openInfoModal} />}

      <LeadModal isOpen={isModalOpen} onClose={closeModal} />
      <InfoModal type={infoModalType} onClose={closeInfoModal} />
    </div>
  );
};

export default App;